import { GoogleOAuthProvider } from '@react-oauth/google';
import { useTenantContext } from './TenantContext';

export function WithGoogleOAuth({ children }: { children: React.ReactNode }) {
  const ctx = useTenantContext();
  const clientId = ctx?.settings?.GOOGLE_OAUTH_CLIENT_ID ?? '';

  return <GoogleOAuthProvider clientId={clientId}>{children}</GoogleOAuthProvider>;
}
